<template>
  <section class="landing-page-employers">
    <PublicNavigation :showForm="showForm" />
    <div class="main-header">
      <div class="center-text">
        <div class="text">
          <img :src="require(`../../../public/img/landing-pages/Jobshark_light.png`)" />
          <h1>
            <span>Introducing Jobshark 2.0</span> The new community for IT Professionals and
            Employers
          </h1>
        </div>
      </div>
    </div>
    <div class="content-section-gray">
      <div class="container">
        <div class="content">
          <h2>
            Experience a <span>user-friendly interface and access powerful features</span> that
            effortlessly <span>connect you with top IT talent!</span>
          </h2>
        </div>
        <section class="statistics">
          <ul class="list-inline d-flex justify-content-between">
            <li
              v-for="(competence, index) in topCompetences"
              v-bind:key="competence.id"
              class="list-inline-item d-flex align-items-center"
            >
              <div class="text">
                <i v-if="competence.devicon !== null" :class="`${competence.devicon} colored`"></i>
                <img v-else src="/img/comstream.svg" alt="Jobshark logo" />
                <span>
                  <number
                    animationPaused
                    :ref="`col${index}`"
                    :format="theFormat"
                    :to="competence.counter"
                    :duration="2"
                    easing="Power1.easeOut"
                    @complete="completed"
                    @click="playAnimation(`col${index}`)"
                  />
                </span>
                <IntersectionObserver
                  v-if="index === 0"
                  sentinal-name="sentinal-name"
                  @on-intersection-element="onIntersectionElement"
                ></IntersectionObserver>
                {{ competence.name }}
              </div>
            </li>
          </ul>
        </section>
      </div>
    </div>
    <div class="content-section-white">
      <div class="container">
        <div class="content">
          <h3>WHAT'S NEW?</h3>
          <span class="orange">DISCOVER JOBSHARK'S <span>INTUITIVE FEATURES</span></span>
          <div v-observe-visibility="animateDiv" class="info-box col-md-11 mx-auto">
            <div class="row">
              <div class="col-md-6">
                <h3>
                  EASY-TO-USE
                  <span>APPLICANT TRACKING </span>
                  FEATURES
                </h3>
              </div>
              <div class="col-md-6">
                <p>
                  Effortlessly track and manage candidates and applications, contact candidates, and
                  stay organized throughout the hiring process using our intuitive tools. By using
                  the pipeline features, you bring the candidate forward in the process while
                  maintaining an overview of the progress of the recruiting process. Streamline your
                  hiring process and stay organized with ease.
                </p>
              </div>
            </div>
            <div class="image-box">
              <span class="shadow-number">1</span>
              <img
                :src="require(`../../../public/img/landing-pages/jobshark-jobs-job-board.jpg`)"
              />
            </div>
          </div>
          <div v-observe-visibility="animateDiv" class="info-box col-md-11 mx-auto">
            <div class="row">
              <div class="col-md-6">
                <h3>MODERN PLATFORM AND ENHANCED BRAND NEW USER INTERFACE</h3>
              </div>
              <div class="col-md-6">
                <p>
                  Gain valuable insights and analytics on your job postings, applicant demographics,
                  and performance metrics to make data-driven decisions and optimize your
                  recruitment strategies.
                </p>
              </div>
            </div>
            <div class="image-box">
              <span class="shadow-number">2</span>
              <img
                :src="require(`../../../public/img/landing-pages/jobshark-candidate-stages.jpg`)"
              />
            </div>
          </div>
          <div v-observe-visibility="animateDiv" class="info-box col-md-11 mx-auto">
            <div class="row">
              <div class="col-md-6">
                <h3>EMAIL INTEGRATION</h3>
              </div>
              <div class="col-md-6">
                <p>
                  Stay organized and collaborate seamlessly with applicants through our
                  out-of-the-box email integration, ensuring effective and timely communication.
                </p>
              </div>
            </div>
            <div class="image-box">
              <span class="shadow-number upper">3</span>
              <img
                :src="require(`../../../public/img/landing-pages/seamless-email-integration.jpg`)"
              />
            </div>
          </div>
          <div v-observe-visibility="animateDiv" class="info-box col-md-11 mx-auto">
            <div class="row">
              <div class="col-md-6">
                <h3>TAILORED MANAGED SERVICES</h3>
              </div>
              <div class="col-md-6">
                <p>
                  Our platform still offers premium managed HR services such as headhunting, but you
                  can now benefit from free basic posting of a job ad as well. We believe that
                  advertising your open roles should be quick and easy and that is exactly what you
                  get with the new Jobshark! Our managed services provide you with personalized
                  assistance in identifying and recruiting highly skilled IT professionals for short
                  or long-term engagement. Run digitalized HR operations with our tailored premium
                  managed services.
                </p>
              </div>
            </div>
            <div class="image-box">
              <span class="shadow-number" style="top: -500px">4</span>
              <img
                :src="require(`../../../public/img/landing-pages/pipeline-tracking-system.jpg`)"
              />
            </div>
          </div>
          <div class="d-flex" style="justify-content: center; margin-bottom: 50px">
            <div class="actions">
              <button
                @click="showFormEvent('employer')"
                class="btn btn-secondary"
                id="register-btn"
              >
                Create a free account
              </button>
              <button @click="showFormEvent('login')" class="btn btn-primary" id="login-btn">
                Log into existing account
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="we-care">
      <div class="col-md-7 mx-auto">
        <div class="d-flex items-center">
          <div class="text">
            <h3>
              WE CARE ABOUT<br />
              WHAT WE DELIVER
            </h3>
            <p>
              Since our start in 2013, we have helped hundreds of companies in finding their new
              exceptional employees and strengthen their Employer Brand online.
            </p>
          </div>
          <div class="log"></div>
        </div>
      </div>
    </div>
    <div class="black-section">
      <div class="col-md-8 mx-auto">
        <div class="d-flex items-center">
          <img :src="require(`../../../public/img/landing-pages/Icon-12.png`)" />
          <div class="text d-flex">
            <div>
              <p>HIRE THE RIGHT IT TALENT TO DRIVE YOUR ORGANIZATION'S SUCCESS WITH JOBSHARK!</p>
              <p style="font-size:18px">
                Log in now to access our exclusive platform and gain a competitive edge in
                attracting the best IT talent.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="intend" class="on-exit animate__animated animate__fadeIn animate__fast">
      <div class="box">
        <div class="content">
          <span @click="intend = false" class="close-button">X</span>
          <div class="text">
            <h3>Wait! Before you go...</h3>
            <p>
              Sign in to advertise your job ad on Jobshark for <strong>FREE</strong> today!
              <br />Don't miss out on the best candidates, register now!
            </p>
            <button @click="showFormEvent('employer')" id="register-two" class="btn btn-secondary">
              Register
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Vue from 'vue';
import { ObserveVisibility } from 'vue-observe-visibility';
import IntersectionObserver from '@/components/common/IntersectionObserver';
import PublicNavigation from '../../components/Navigations/PublicNavigation';
import { BRANDS } from '../../constants';
import carousel from 'vue-owl-carousel';
import exitIntent from 'exit-intent';
import CustomMainModal from '@/components/Modals/CustomMainModal';
import VerificationCodeEmployer from '../PublicPagesBase/VerificationCodeEmployer';
import Spinner from '../../components/common/LoadingSpinner/Spinner';
import Signin from '@/components/Signin/Signin';
import axios from 'axios';
import ResetPassword from '../../components/ResetPassword/ResetPassword';
import titleMixin from '../../mixins/titleMixin';
Vue.directive('observe-visibility', ObserveVisibility);
export default {
  mixins: [titleMixin],
  title: 'Discover Jobshark & Streamline your IT Recruitment | Jobshark',
  components: {
    IntersectionObserver,
    carousel,
    PublicNavigation,
    CustomMainModal,
    Spinner,
    VerificationCodeEmployer,
    Signin,
    ResetPassword,
  },
  data: () => ({
    showForm: {
      formType: '',
      count: 0,
    },
    inViewport: {
      now: false, // Is some part of the component currently in the viewport?
      fully: false, // Is the component completely in the viewport?
      above: false, // Is any part of the component above the viewport?
      below: false, // Is any part of the component below the viewport?
    },
    topCompetences: [],
    brands: BRANDS,
    intend: false,
    retoken: '',
    isLoading: false,
    modalTitle: '',
    jobAds: [],
    promotedJobAds: [],
    sendLocation: [],
    keywords: [],
    locationsOptions: [],
    postFreeJob: {
      phone: '',
      email: '',
      companyName: '',
      countryId: '',
      address: '',
      postal: '',
      city: '',
      cityId: '',
      countryName: '',
      corporateWebsite: '',
      firstName: '',
      lastName: '',
      password: '',
      phone_code: '',
      isAgree: false,
      campaign_id: null,
      campaign_medium: null,
      campaign_name: null,
      campaign_source: null,
    },
  }),
  methods: {
    ...mapActions([
      'fetchAllJobResults',
      'retrieveEmployersDropdownCandidate',
      'retrieveCompetencesList',
      'searchLocationByName',
      'retrieveCitiesListByCountryId',
      'retrieveLanguagesList',
      'retrieveAllCountries',
    ]),
    showFormEvent(type) {
      this.showForm.formType = type;
      this.showForm.count++;
    },
    animateDiv(isVisible, entry) {
      if (isVisible) {
        // trigger animation for the element
        let domElement = entry.target;
        domElement.classList.add('animate__animated', 'animate__fadeInUp');
      }
    },
    handleExitIntent() {
      this.intend = true;
    },
    toggleForms() {
      this.showVerification = false;
    },

    getDefaultCountry() {
      axios
        .get(`${process.env.VUE_APP_API_URL}/common/address/getaddressbyip`, {
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
        })
        .then(({ data }) => {
          if (data.country_name !== null) {
            this.postFreeJob.countryName = data.country_name;
          } else {
            this.postFreeJob.countryName = '';
          }
          if (data.country_id !== null) {
            this.postFreeJob.countryId = data.country_id;
          } else {
            this.postFreeJob.countryId = '';
          }
          if (data.country_name !== null) {
            this.postFreeJob.phone_code = data.country_name;
          } else {
            this.postFreeJob.phone_code = '';
          }
          if (data.phone_code !== null) {
            this.postFreeJob.phone = `${data.phone_code} `;
          } else {
            this.postFreeJob.phone = '';
          }
          if (data.city_name !== null) {
            this.postFreeJob.city = data.city_name;
          } else {
            this.postFreeJob.city = '';
          }
          if (data.city_id !== null) {
            this.postFreeJob.cityId = data.city_id;
          } else {
            this.postFreeJob.cityId = '';
          }
          if (data.city_postal_code !== null) {
            this.postFreeJob.postal = data.city_postal_code;
          } else {
            this.postFreeJob.postal = '';
          }

          this.retrieveCitiesListByCountryId({ id: this.postFreeJob.countryId });
        });
    },

    addCountryCode(code) {
      this.postFreeJob.phone_code = code.replace(/[0-9+]/g, '');
      this.postFreeJob.phone = code.substring(0, code.indexOf(' ')) + ' ';
    },

    next() {
      if (this.step < 2) {
        this.step++;
      }
    },
    prev() {
      this.step--;
    },

    validate(el) {
      if (el.target.required === true && el.target.value === '') {
        el.target.classList.add('is-invalid');
      } else {
        el.target.classList.remove('is-invalid');
      }

      if (el.target.type === 'email') {
        this.validateEmail(this.postFreeJob.email);
      }

      if (el.target.type === 'password' && el.target.value.length < 8) {
        el.target.classList.add('is-invalid');
      } else {
        el.target.classList.remove('is-invalid');
      }
    },

    validateEmail(email) {
      const emailRe = /^(([^<>()[\]\\.,;:#/\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      // const emailRe = /^(([^<>()\[\]\\.,;:#/\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (email.length > 0) {
        if (emailRe.test(email)) {
          this.postFreeJob.emailNotFalid = false;
          this.postFreeJob.emailValidated = true;
        } else {
          this.postFreeJob.emailNotFalid = true;
          this.postFreeJob.emailValidated = false;
        }
      }
    },

    fetchOptions(search, loading) {
      if (search.length < 3) {
        this.locationsOptions = [];
      }

      if (search.length >= 3) {
        loading(true);

        this.searchLocationByName(search)
          .then(response => {
            const citiesList = response.data.cities;
            const countriesList = response.data.countries;
            const concatedLists = [].concat(countriesList, citiesList);
            this.locationsOptions = concatedLists;
            loading(false);
          })
          .catch(err => {
            loading(false);
            this.$toasted.error(errorService(err), {
              theme: 'bubble',
              icon: 'fa-times-circle',
              position: 'bottom-right',
              duration: 8000,
            });
          });
      }
    },

    fetchCitisByC(e) {
      this.postFreeJob.countryName = e.name;
      this.postFreeJob.countryId = e.id;
      this.retrieveCitiesListByCountryId({ id: this.postFreeJob.countryId });
      this.postFreeJob.city = '';
      this.postFreeJob.cityId = '';
    },
    openPostJob() {
      this.showModalJob = true;
    },

    fetchCitisByCountryId(e) {
      this.postFreeJob.city = '';
      this.postFreeJob.cityId = '';
      this.postFreeJob.countryName = e.name;
      this.postFreeJob.countryId = e.id;
      this.retrieveCitiesListByCountryId({ id: this.postFreeJob.countryId });
    },

    getCaptcha() {
      let vm = this;
      const REG = () => this.registerEmployer();
      grecaptcha
        .execute('6LdyDhspAAAAAJWVsgRkufJ8fAJBeSDpWDPUsvAn', { action: 'submit' })
        .then(function(token) {
          vm.reToken = token;
          REG();
        });
    },

    registerEmployer() {
      if (!this.postFreeJob.isAgree) {
        this.$toasted.error(
          `Please agree to Jobshark's General Conditions for Employers to register`,
          {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 5000,
          },
        );
        return false;
      }

      this.isLoading = true;

      axios({
        method: 'post',
        url: `${process.env.VUE_APP_API_URL}/manager/auth/register`,
        data: {
          email: this.postFreeJob.email,
          password: this.postFreeJob.password,
          company_name: this.postFreeJob.companyName,
          first_name: this.postFreeJob.firstName,
          last_name: this.postFreeJob.lastName,
          city_id: this.postFreeJob.cityId,
          country_id: this.postFreeJob.countryId,
          street_address: this.postFreeJob.address,
          website: this.postFreeJob.corporateWebsite,
          phone_number: this.postFreeJob.phone,
          country_code: this.postFreeJob.phone_code,
          postal_code: this.postFreeJob.postal,
          privacy: this.postFreeJob.isAgree,
          'g-recaptcha-response': this.reToken,
          campaign_id: this.postFreeJob.campaign_id,
          campaign_medium: this.postFreeJob.campaign_medium,
          campaign_name: this.postFreeJob.campaign_name,
          campaign_source: this.postFreeJob.campaign_source,
        },
      })
        .then(response => {
          localStorage.setItem('uuid', response.data.id);

          this.showVerification = true;
          this.isLoading = false;
        })

        .catch(err => {
          this.isLoading = false;
          this.$toasted.error(`${err.response.data.message}`, {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 5000,
          });
        });
    },
    /*     openModal(e) {
      this.showModal = true;

      if (e.target.id == 'login-btn') {
        this.modalTitle = 'Sign In';
        this.showLogin = true;
        this.showRegister = false;
        this.showResetPassword = false;
        this.showVerification = false;
      } else if (e.target.id == 'register-btn' || e.target.id == 'register-two') {
        this.modalTitle = 'Register Employer';
        this.showLogin = false;
        this.showResetPassword = false;
        this.showRegister = true;
      } else if (e.target.id == 'register-link') {
        this.modalTitle = 'Register Employer';
        this.showRegister = true;
        this.showLogin = false;
        this.showResetPassword = false;
      } else if (e.target.id == 'forgotten-password') {
        this.modalTitle = 'Reset Password';
        this.showRegister = false;
        this.showLogin = false;
        this.showResetPassword = true;
      } else if (e.target.id == 'already-have-account') {
        this.modalTitle = 'Sign In';
        this.showLogin = true;
        this.showRegister = false;
        this.showResetPassword = false;
      }
    }, */
    onIntersectionElement() {
      const colsList = Object.keys(this.$refs);

      colsList.forEach(item => {
        this.$refs[item][0].play();
      });
    },
    theFormat(number) {
      return number.toFixed(0);

      /* return number.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ','); */
    },
    completed() {
      //  console.log('Animation ends!');
    },
    playAnimation(col) {
      this.$refs[col].play();
    },
    getTopTenCompetences() {
      axios
        .get(`${process.env.VUE_APP_API_URL}/common/competence/topcompetences`, {
          headers: {
            Authorization: `Bearer ${this.getToken}`,
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
        })
        .then(({ data }) => {
          if (window.innerWidth < 601) {
            this.topCompetences = data.slice(0, -4);
          }
          if (window.innerWidth >= 601 && window.innerWidth <= 1000) {
            this.topCompetences = data.slice(0, -2);
          }
          if (window.innerWidth > 1000) {
            this.topCompetences = data.slice(0, -2);
          }
        });
    },
    getCampainParams() {
      if (this.$route.query.utm_id) {
        this.postFreeJob.campaign_id = this.$route.query.utm_id;
      }
      if (this.$route.query.utm_medium) {
        this.postFreeJob.campaign_medium = this.$route.query.utm_medium;
      }
      if (this.$route.query.utm_campaign) {
        this.postFreeJob.campaign_name = this.$route.query.utm_campaign;
      }
      if (this.$route.query.utm_source) {
        this.postFreeJob.campaign_source = this.$route.query.utm_source;
      }
    },
  },
  watch: {
    postFreeJob: {
      handler(val) {
        if (val.companyName && val.countryId && val.address && val.postal && val.cityId) {
          this.nextStep = true;
        } else {
          this.nextStep = false;
        }
        if (
          this.nextStep &&
          val.firstName &&
          val.lastName &&
          val.password.length >= 8 &&
          val.phone &&
          val.email.length > 0
        ) {
          this.canPost = true;
        } else {
          this.canPost = false;
        }
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters([
      'getNextPage',
      'getTotalPages',
      'getCurrentPage',
      'getAllCountries',
      'allSearchJobResults',
      'getCompetencesFilterList',
      'getCitiesListByCountry',
      'getEmployersDropdownCandidate',
    ]),
  },
  mounted() {
    this.getCampainParams();
    this.getTopTenCompetences();
    this.getDefaultCountry();
    setTimeout(() => {
      this.removeExitIntent = exitIntent({
        threshold: 10,
        maxDisplays: 1,
        eventThrottle: 200,
        onExitIntent: () => {
          this.handleExitIntent();
        },
      });
    }, 2000);
  },
  beforeDestroy() {
    if (this.removeExitIntent) {
      this.removeExitIntent();
    }
  },
};
</script>

<style lang="scss" scoped>
@import './src/assets/scss/_variables.scss';

.form-group.required {
  position: relative;

  &:after {
    content: '*';
    font-size: 22px;
    position: absolute;
    top: 0px;
    right: 26px;
    color: red;
    opacity: 0.6;
  }
}

.form-group.required-right {
  position: relative;

  &:after {
    content: '*';
    font-size: 22px;
    position: absolute;
    top: 0px;
    right: 10px;
    color: red;
    opacity: 0.6;
  }
}

.form-group.required-fixed-right {
  position: relative;

  &:after {
    content: '*';
    font-size: 22px;
    position: absolute;
    top: 0px;
    right: 6px;
    color: red;
    opacity: 0.6;
  }
}

.form-group.required-fixed-drop {
  position: relative;

  &:after {
    content: '*';
    font-size: 22px;
    position: absolute;
    top: 0px;
    right: 25px;
    color: red;
    opacity: 0.6;
  }
}

.statistics {
  padding: 0 0 30px 0;

  h2 {
    margin-bottom: 30px;
  }

  .list-inline {
    margin: 0;
    font-family: $font-family-sans-lato;
    flex-wrap: wrap;

    li {
      width: 20%;
      text-align: center;
      font-size: 16px;
      border: 1px solid rgba(0, 0, 0, 0.02);
      width: 105px;
      height: 105px;
      color: #888;
      border-radius: 6px;
      -webkit-box-shadow: 0px 15px 35px #0000000d;
      box-shadow: 0px 15px 35px #0000000d;
      background: #fff;

      .text {
        width: 100%;

        span {
          display: block;
          margin: 4px auto;
          font-weight: 700;
          color: #575757;
        }

        i {
          display: block;
          font-size: 41px;
        }

        img {
          width: 42px;
          height: 42px;
        }
      }
    }
  }
}
.multisteps-form__progress {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(0, 1fr));
}

.multisteps-form__progress-btn {
  transition-property: all;
  transition-duration: 0.15s;
  transition-timing-function: linear;
  transition-delay: 0s;
  position: relative;
  padding-top: 20px;
  color: rgba(108, 117, 125, 0.7);
  text-indent: -9999px;
  border: none;
  background-color: transparent;
  outline: none !important;
  cursor: pointer;
}

.no-padding {
  padding-left: 8px;
  padding-top: 15px;
}

@media (min-width: 500px) {
  .multisteps-form__progress-btn {
    text-indent: 0;
  }
}

.multisteps-form__progress-btn:before {
  position: absolute;
  top: 0;
  left: 50%;
  display: block;
  width: 13px;
  height: 13px;
  content: '';
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  transition: all 0.15s linear 0s, -webkit-transform 0.15s cubic-bezier(0.05, 1.09, 0.16, 1.4) 0s;
  transition: all 0.15s linear 0s, transform 0.15s cubic-bezier(0.05, 1.09, 0.16, 1.4) 0s;
  transition: all 0.15s linear 0s, transform 0.15s cubic-bezier(0.05, 1.09, 0.16, 1.4) 0s,
    -webkit-transform 0.15s cubic-bezier(0.05, 1.09, 0.16, 1.4) 0s;
  border: 2px solid currentColor;
  border-radius: 50%;
  background-color: #fff;
  box-sizing: border-box;
  z-index: 3;
}

.multisteps-form__progress-btn:after {
  position: absolute;
  top: 5px;
  left: calc(-50% - 13px / 2);
  transition-property: all;
  transition-duration: 0.15s;
  transition-timing-function: linear;
  transition-delay: 0s;
  display: block;
  width: 100%;
  height: 2px;
  content: '';
  background-color: currentColor;
  z-index: 1;
}

.multisteps-form__progress-btn:first-child:after {
  display: none;
}

.multisteps-form__progress-btn.js-active {
  color: #0088cc;
}

.multisteps-form__progress-btn.js-active:before {
  -webkit-transform: translateX(-50%) scale(1.2);
  transform: translateX(-50%) scale(1.2);
  background-color: currentColor;
}
.landing-page-employers {
  .main-header {
    position: relative;
    min-height: 100vh;
    background: url('../../../public/img/landing-pages/Header.jpg');
    background-size: cover;
    margin: 0;
    .center-text {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      .text {
        text-align: center;
        width: 460px;
        padding-top: 100px;
        img {
          width: 180px;
          height: 180px;
        }
        h1 {
          font-size: 2.1rem;
          span {
            font-weight: 900;
            display: block;
          }
        }
      }
    }
  }

  .content-section-gray {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 60px 0 0px 0;
    background-color: #ebeced;
    .content {
      padding: 80px 120px;
      h2 {
        font-size: 36px;
        font-weight: 500;
        text-align: center;
        span {
          &:first-of-type {
            font-weight: 600;
            color: #08c;
          }
          &:nth-of-type(2) {
            font-weight: 600;
            display: block;
          }
        }
      }
    }
  }

  .content-section-white {
    padding: 50px 0;
    background-color: #fff;

    .content {
      .actions {
        .btn {
          display: block;
          font-size: 21px;
          width: 350px;
          margin-bottom: 12px;
          font-size: 21px;
          padding: 12px 55px;
        }
      }
      .orange {
        display: block;
        text-transform: uppercase;
        color: #f26622;
        font-size: 38px;
        text-align: center;
        margin-top: 30px;
        line-height: 1.2;
        span {
          display: block;
        }
      }
      h3 {
        font-weight: 900;
        text-align: center;
        margin: 40px 0 0px 0;
        font-size: 36px;
      }
    }

    .info-box {
      position: relative;
      margin: 100px auto;

      .col-md-6 {
        z-index: 999;
      }

      h3 {
        text-transform: uppercase;
        text-align: left;
        font-size: 2.2rem;
        font-weight: 400;
        z-index: 9999;

        span {
          display: block;
        }
      }

      p {
        font-size: 21px;
        margin-bottom: 80px;
      }

      .image-box {
        position: relative;

        .shadow-number {
          position: absolute;
          top: -385px;
          left: 255px;
          font-size: 348px;
          font-weight: 900;
          color: #ebeced;
          z-index: 0;
          height: 100px;
          opacity: 0.8;
          &.upper {
            top: -390px;
          }
        }

        img {
          width: 100%;
        }
      }
    }
  }
  .we-care {
    padding: 120px 0;
    background: url('../../../public/img/landing-pages/WE-CARE-ABOUT.jpg');
    .text {
      width: 65%;
      h3 {
        color: #fff;
        font-weight: 900;
        font-size: 42px;
        margin-bottom: 50px;
      }
      p {
        color: #fff;
        font-size: 20px;
        font-weight: 500;
        margin-bottom: 0;
      }
    }
    .log {
      flex: 1;
      justify-content: flex-end;
      display: flex;
      align-items: flex-end;
      .btn-primary {
        background: #fff;
        color: #000;
        border: none !important;
        text-transform: uppercase;
        font-size: 18px;
        font-weight: 500;
        padding: 8px 85px;
      }
    }
  }
  .black-section {
    height: 360px;
    background: #222325;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 180px;
      height: auto;
      margin-right: 40px;
      flex-shrink: 0;
    }
    .text {
      text-align: right;
      align-items: center;
      p {
        font-size: 24px;
      }
    }
  }
}
.brands {
  padding: 50px 0 0 0;

  h3 {
    text-transform: uppercase;
    text-align: center;
    font-size: 34px;
    margin-bottom: 50px;
  }
  img {
    filter: grayscale(100%);
    &:hover {
      filter: grayscale(0);
    }
  }
}

.on-exit {
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  z-index: 9;
  .box {
    width: 670px;
    height: 350px;
    background: #fff;
    border-radius: 22px;
    border: 1px solid #ddd;
    padding: 22px;
    position: relative;
    background: url('../../../public/img/landing-pages/wait.png') no-repeat;
    background-color: #fff;
    background-size: contain;
    .content {
      position: relative;
      display: flex;
      .close-button {
        position: absolute;
        top: 0px;
        right: 20px;
        cursor: pointer;
        font-weight: 900;
        color: #666;
      }
      .text {
        padding: 30px 0;
        width: 50%;
        margin-left: auto;
        h3 {
          font-weight: 900;
          color: #f26622;
          font-size: 26px;
          margin-bottom: 20px;
        }
        p {
          font-size: 15px;
        }
        .btn-secondary {
          padding: 8px 30px;
          font-size: 18px;
          font-weight: 600;
        }
      }
    }
  }
}

/* Extra small devices (phones, 600px and down) */
@media only screen and (max-width: 600px) {
  .statistics {
    .list-inline {
      li {
        margin: 30px 0 12px 0;
      }
    }
  }
  .landing-page-employers {
    .main-header {
      min-height: 50vh;
      background-position: top;
      background-size: 1000px;
      .center-text {
        .text {
          h1 {
            font-size: 1.1rem;
            padding: 0 30px;
          }
          img {
            width: 100px;
            height: 100px;
          }
        }
      }
    }
    .content-section-gray {
      .content {
        padding: 0 20px;
        h2 {
          font-size: 1.6rem;
          &.bold {
            font-size: 1.6rem;
          }
          &.sm {
            font-size: 18px;
          }
        }
        p {
          font-size: 18px;
        }
        .d-flex {
          display: block !important;
          .btn {
            display: block;
            width: 100%;
            margin-bottom: 12px;
          }
        }
      }
    }

    .content-section-white {
      overflow: hidden;
      .content {
        h3 {
          font-size: 32px;
        }
        .orange {
          font-size: 1.6rem;
        }
      }
      .info-box {
        margin: 25px auto;
        h3 {
          font-size: 26px;
          margin-bottom: 12px;
        }
        p {
          font-size: 18px;
          margin-bottom: 30px;
        }
      }
    }
    .we-care {
      padding: 50px 0;
      .d-flex {
        display: block !important;
        .text {
          text-align: center;
          width: 100%;
          margin-bottom: 50px;
          h3 {
            text-align: center;
            font-size: 32px;
          }
        }
        .log {
          .btn-primary {
            margin: 0 auto;
          }
        }
      }
    }
    .black-section {
      display: block;
      height: auto;
      padding: 40px 0;
      .text {
        text-align: center;
      }
      .d-flex {
        display: block !important;
        img {
          display: none;
        }
      }
    }
  }
}

/* Small devices (portrait tablets and large phones, 600px and up) */
@media only screen and (min-width: 601px) and (max-width: 768px) {
  .statistics {
    .list-inline {
      li {
        margin: 30px 20px 12px 20px;
      }
    }
  }
  .landing-page-employers {
    .main-header {
      min-height: 55vh;
      background-position: top;
      background-size: 1000px;
      .center-text {
        .text {
          h1 {
            font-size: 1.3rem;
            padding: 0 30px;
          }
          img {
            width: 100px;
            height: 100px;
          }
        }
      }
    }
    .content-section-gray {
      .content {
        padding: 0 20px;
        h2 {
          font-size: 1.6rem;
          &.bold {
            font-size: 1.6rem;
          }
          &.sm {
            font-size: 18px;
          }
        }
        p {
          font-size: 18px;
        }
        .d-flex {
          display: block !important;
          .btn {
            display: block;
            width: 100%;
            margin-bottom: 12px;
          }
        }
      }
    }

    .content-section-white {
      overflow: hidden;
      .content {
        h3 {
          font-size: 32px;
        }
        .orange {
          font-size: 1.6rem;
        }
      }
      .info-box {
        margin: 25px auto;
        h3 {
          font-size: 26px;
          margin-bottom: 12px;
        }
        p {
          font-size: 18px;
          margin-bottom: 30px;
        }
      }
    }
    .we-care {
      padding: 50px 0;
      .d-flex {
        display: block !important;
        .text {
          text-align: center;
          width: 100%;
          margin-bottom: 50px;
          h3 {
            text-align: center;
            font-size: 32px;
          }
        }
        .log {
          .btn-primary {
            margin: 0 auto;
          }
        }
      }
    }
    .black-section {
      display: block;
      height: auto;
      padding: 40px 0;
      .text {
        text-align: center;
      }
      .d-flex {
        display: block !important;
        img {
          display: none;
        }
      }
    }
  }
}

/* Medium devices (landscape tablets, 769px and up) */
@media only screen and (min-width: 769px) and (max-width: 992px) {
  .container {
    max-width: 100% !important;
  }
  .statistics {
    margin-top: 30px;
    .list-inline {
      li {
        margin: 30px 40px 12px 40px;
      }
    }
  }
  .landing-page-employers {
    .main-header {
      min-height: 65vh;
      background-position: top;
      background-size: 1000px;
      .center-text {
        .text {
          h1 {
            font-size: 1.5rem;
            padding: 0 30px;
          }
          img {
            width: 100px;
            height: 100px;
          }
        }
      }
    }
    .content-section-gray {
      .content {
        padding: 0 20px;
        h2 {
          font-size: 1.6rem;
          &.bold {
            font-size: 1.6rem;
          }
          &.sm {
            font-size: 18px;
          }
        }
        p {
          font-size: 18px;
        }
        .d-flex {
          display: block !important;
          .btn {
            display: block;
            width: 100%;
            margin-bottom: 12px;
          }
        }
      }
    }

    .content-section-white {
      overflow: hidden;
      .content {
        h3 {
          font-size: 32px;
        }
        .orange {
          font-size: 1.6rem;
        }
      }
      .info-box {
        margin: 25px auto;
        h3 {
          font-size: 26px;
          margin-bottom: 12px;
        }
        p {
          font-size: 18px;
          margin-bottom: 30px;
        }
      }
    }
    .we-care {
      padding: 50px 0;
      .d-flex {
        display: block !important;
        .text {
          text-align: center;
          width: 100%;
          margin-bottom: 50px;
          h3 {
            text-align: center;
            font-size: 32px;
          }
        }
        .log {
          .btn-primary {
            margin: 0 auto;
          }
        }
      }
    }
    .black-section {
      display: block;
      height: auto;
      padding: 40px 0;
      .text {
        text-align: center;
      }
      .d-flex {
        display: block !important;
        img {
          display: none;
        }
      }
    }
  }
}

@media only screen and (min-width: 450px) and (max-width: 546px) {
  .statistics {
    .list-inline {
      li {
        margin: 30px 12px 12px 12px;
      }
    }
  }
}

@media only screen and (min-width: 547px) and (max-width: 600px) {
  .statistics {
    .list-inline {
      li {
        margin: 30px 20px 12px 20px;
      }
    }
  }
}
</style>
